import { IconProps } from "../../utils/global-types/global-types";

const PoundIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <mask
        id="mask0_8462_99984"
        width="12"
        height="12"
        x="3"
        y="3"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
      >
        <path fill="#fff" d="M3 3h12v12H3z"></path>
      </mask>
      <g mask="url(#mask0_8462_99984)">
        <path
          fill="currentColor"
          d="M10.596 15a3.8 3.8 0 0 1-2.22-.723l-.046-.036a1.84 1.84 0 0 0-1.747-.327l-.123.049-.055.02a1.8 1.8 0 0 0-.59.427l-.397.431-1.378-1.267.396-.431c.401-.437.91-.775 1.47-.977a2.21 2.21 0 0 0 1.297-2.135h-2.46V8.158h1.63A3.708 3.708 0 0 1 9.782 3c.802 0 1.565.252 2.207.728a3.7 3.7 0 0 1 1.323 1.85l-1.785.568a1.825 1.825 0 0 0-1.745-1.273c-1.01 0-1.83.821-1.83 1.83 0 .402.128.845.602 1.455h2.98v1.873H9.077a4.04 4.04 0 0 1-.546 2.179c.348.138.674.328.967.567.386.273.868.395 1.324.336.51-.067.972-.348 1.267-.771l.334-.481 1.537 1.07-.334.48A3.71 3.71 0 0 1 10.596 15"
        ></path>
      </g>
    </svg>
  );
};

export default PoundIcon;
